import React from 'react';
import { Container, Row } from 'reactstrap';
import AccountAmcInstancePage from './components/AccountAmcInstancePage';
import PageHeader from '../../../../shared/components/PageHeader';

const AccountAmcInstance = () => (
  <Container>
    <Row>
      <PageHeader title="Account AMC Instance" subhead="Setup and configure this accounts Amazon AMC Instance" />
    </Row>
    <Row>
      <AccountAmcInstancePage />
    </Row>
  </Container>
);

export default AccountAmcInstance;

